import React from "react";

const Blog: React.FC = () => {
      const useScrollToTop = () => {
        React.useEffect(() => {
          window.scrollTo(0, 0);
        }, []);
      }
      useScrollToTop();
    return (
        <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-4">Blog</h1>
        <p className="text-gray-700 mb-4">
            Welcome to our blog! Here you will find the latest news and updates.
        </p>
        {/* Add your blog content here */}
        </div>
    );
    }
export default Blog;